import React, { useEffect, useState } from 'react';
import { Mutation, Query, withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import moment from 'moment';
import withSession from '../../lib/withSession';
import { withToastManager } from 'react-toast-notifications/dist/ToastProvider';
import { isMobile } from 'react-device-detect';
import withOnFileInsurance from '../../lib/withOnFileInsurance';
import { APPOINTMENTS, GET_CLINICAL_PROVIDERS_DOCTOR } from '../../graphql';
import SpinLoader from '../../components/SpinLoader';
import PleaseWait from '../../components/PleaseWait';
import { ButtonWithSelectionCircle, ButtonWithSelectionCircleSelectedMarkerIn, ButtonWithSelectionCircleSelectedMarkerOut } from '../../components/intake/components/ButtonWithSelectionCircle';
import { isAsyncAppointment, isMenoAppointment, isNutritionistAppointment, isWeightLossAppointment } from '../../utils/appointments';
import { isToggleActive } from '../../components/featureToggle/toggles';
import { isPreviewMode } from '../../utils/environments';
import gql from 'graphql-tag';

const Container = styled(Box)`
  max-width: 600px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow-y: ${(props) => (isMobile ? 'hidden' : '')};
`;

const InnerContainerInformation = styled(Flex)`
  max-width: ${(props) => (isMobile ? 'calc(100% - 12px)' : '850px')};
  height: auto;
  margin: 0 auto;
  max-height: 100%;
  flex-direction: column;
  overflow-y: ${(props) => (isMobile ? 'auto' : '')};
`;

const InnerWithMenopause = ({ ...props }) => {
  const { canBookNoHypo, canBookVisit } = props;
  const { b2b } = props.session;

  const isRestrictedHypo = () => {
    if (b2b && b2b.restrictions && b2b.restrictions.hypo) return true;

    return false;
  };
  const isRestrictedMeno = () => {
    if (b2b && b2b.restrictions && b2b.restrictions.meno) return true;

    return false;
  };
  const isRestrictedWeightloss = () => {
    if (b2b && b2b.restrictions && b2b.restrictions.weightloss) return true;

    return false;
  };
  return (
    <Query query={APPOINTMENTS}>
      {({ data: dataUpcomings, loading: loadingUpcoming }) => {
        return (
          <Query
            query={GET_CLINICAL_PROVIDERS_DOCTOR}
            variables={{
              departmentId: props.session.department.departmentId,
            }}
          >
            {({ data: dataProviders, loading: loadingProviders }) => {
              if (!!loadingProviders || !!loadingUpcoming)
                return (
                  <Container alignItems={'center'} justifyContent={'center'} id="pplpl">
                    <PleaseWait />
                  </Container>
                );

              if (!props.isDeepLoaded) {
                props.onLoaded();
              }

              const upcomings = ((dataUpcomings || {}).appointments || [])
                .filter((item) => {
                  if (
                    item.status &&
                    item.status === 'f' &&
                    !isAsyncAppointment(item.appointmentTypeId) &&
                    !isMenoAppointment(item.appointmentTypeId) &&
                    !isWeightLossAppointment(item.appointmentTypeId) &&
                    !isNutritionistAppointment(item.appointmentTypeId)
                  ) {
                    return true;
                  }
                  return false;
                })
                .sort((a, b) => {
                  const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                  const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                  if (ma.isBefore(mb)) return -1;
                  return 1;
                });

              const upcomingsMeno = ((dataUpcomings || {}).appointments || [])
                .filter((item) => {
                  if (item.status && item.status === 'f' && isMenoAppointment(item.appointmentTypeId)) {
                    return true;
                  }
                  return false;
                })
                .sort((a, b) => {
                  const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                  const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                  if (ma.isBefore(mb)) return -1;
                  return 1;
                });

              const upcomingsWeightLoss = ((dataUpcomings || {}).appointments || [])
                .filter((item) => {
                  if (item.status && item.status === 'f' && isWeightLossAppointment(item.appointmentTypeId)) {
                    return true;
                  }
                  return false;
                })
                .sort((a, b) => {
                  const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
                  const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
                  if (ma.isBefore(mb)) return -1;
                  return 1;
                });

              if (
                !canBookNoHypo &&
                !canBookVisit &&
                (!props.session.eligibility || (!props.session.eligibility.canBookPerimenopause && !props.session.eligibility.canBookPostmenopause && !props.session.eligibility.canBookWeightLoss))
              ) {
                props.history.push('/');
                return null;
              }
              if (!canBookNoHypo && !canBookVisit) {
                if (!dataProviders || !dataProviders.getClinicalProvidersDoctorsList || dataProviders.getClinicalProvidersDoctorsList.length < 1) {
                  props.history.push('/');
                  return null;
                }
                if (props.session.eligibility && props.session.eligibility.canBookPerimenopause) {
                  if (dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.periMenopause).length < 1) {
                    props.history.push('/');
                    return null;
                  }
                } else if (props.session.eligibility && props.session.eligibility.canBookPostmenopause) {
                  if (dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.postMenopause).length < 1) {
                    props.history.push('/');
                    return null;
                  }
                } else if (props.session.eligibility && props.session.eligibility.canBookWeightLoss) {
                  if (dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.weightLoss).length < 1) {
                    props.history.push('/');
                    return null;
                  }
                }
              } else {
                if (!dataProviders || !dataProviders.getClinicalProvidersDoctorsList || dataProviders.getClinicalProvidersDoctorsList.length < 1) {
                  props.history.push('/scheduler');
                  return null;
                }
                if (props.session.eligibility && props.session.eligibility.canBookPerimenopause) {
                  if (dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.periMenopause).length < 1) {
                    props.history.push('/scheduler');
                    return null;
                  }
                } else if (props.session.eligibility && props.session.eligibility.canBookPostmenopause) {
                  if (dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.postMenopause).length < 1) {
                    props.history.push('/scheduler');
                    return null;
                  }
                } else if (props.session.eligibility && props.session.eligibility.canBookWeightLoss) {
                  if (dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.weightLoss).length < 1) {
                    props.history.push('/scheduler');
                    return null;
                  }
                }
              }

              if (dataProviders && dataProviders.getClinicalProvidersDoctorsList && dataProviders.getClinicalProvidersDoctorsList.length > 0) {
                return (
                  <>
                    {props.session.eligibility && props.session.eligibility.canBookPerimenopause ? (
                      <>
                        {dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.periMenopause).length > 0 && (
                          <ButtonWithSelectionCircle
                            type="button"
                            variant={'white'}
                            mb={4}
                            onClick={() => props.history.push('/scheduler-meno')}
                            disabled={(!!upcomingsMeno && upcomingsMeno.length > 0) || isRestrictedMeno()}
                          >
                            <Flex flex={1} flexDirection="column">
                              <Text textAlign="left" mt="4px">
                                Book peri-menopause visit
                              </Text>
                              {!!upcomingsMeno &&
                                upcomingsMeno.length > 0 && (
                                  <Text textAlign="left" mt="4px">
                                    {`Visit scheduled for ${upcomingsMeno[0].date} ${moment(upcomingsMeno[0].startTime, 'HH:mm').format('hh:mm A')}`}
                                  </Text>
                                )}
                            </Flex>
                          </ButtonWithSelectionCircle>
                        )}
                      </>
                    ) : props.session.eligibility && props.session.eligibility.canBookPostmenopause ? (
                      <>
                        {dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.postMenopause).length > 0 && (
                          <ButtonWithSelectionCircle
                            type="button"
                            variant={'white'}
                            mb={4}
                            onClick={() => props.history.push('/scheduler-meno')}
                            disabled={(!!upcomingsMeno && upcomingsMeno.length > 0) || isRestrictedMeno()}
                          >
                            <Flex flex={1} flexDirection="column">
                              <Text textAlign="left" mt="4px">
                                Book menopause visit
                              </Text>
                              {!!upcomingsMeno &&
                                upcomingsMeno.length > 0 && (
                                  <Text textAlign="left" mt="4px">
                                    {`Visit scheduled for ${upcomingsMeno[0].date} ${moment(upcomingsMeno[0].startTime, 'HH:mm').format('hh:mm A')}`}
                                  </Text>
                                )}
                            </Flex>
                          </ButtonWithSelectionCircle>
                        )}
                      </>
                    ) : null}
                    {props.session.eligibility &&
                      props.session.eligibility.canBookWeightLoss &&
                      props.session.weightLossIntakeStatus !== 'disqualified' && (
                        <>
                          {dataProviders.getClinicalProvidersDoctorsList.filter((x) => !!x.weightLoss).length > 0 && (
                            <ButtonWithSelectionCircle
                              type="button"
                              variant={'white'}
                              mb={4}
                              onClick={() => {
                                if (!props.session.isWeightLossMember || (!!props.session.isWeightLossMember && props.session.prequalWLStatus !== 'PASS')) {
                                  props.history.push('/wlm-schedule');
                                } else {
                                  props.history.push('/schedulewl');
                                }
                              }}
                              disabled={(!!upcomingsWeightLoss && upcomingsWeightLoss.length > 0) || isRestrictedWeightloss()}
                            >
                              <Flex flex={1} flexDirection="column">
                                <Text textAlign="left" mt="4px">
                                  Book weight loss visit
                                </Text>
                                {!!upcomingsWeightLoss &&
                                  upcomingsWeightLoss.length > 0 && (
                                    <Text textAlign="left" mt="4px">
                                      {`Visit scheduled for ${upcomingsWeightLoss[0].date} ${moment(upcomingsWeightLoss[0].startTime, 'HH:mm').format('hh:mm A')}`}
                                    </Text>
                                  )}
                              </Flex>
                            </ButtonWithSelectionCircle>
                          )}
                        </>
                      )}
                    {canBookVisit ? (
                      <ButtonWithSelectionCircle
                        type="button"
                        variant={'white'}
                        onClick={() => props.history.push('/scheduler')}
                        disabled={(!!upcomings && upcomings.length > 0) || isRestrictedHypo()}
                      >
                        <Flex flex={1} flexDirection="column">
                          <Text textAlign="left" mt="4px">
                            Book thyroid visit
                          </Text>
                          {!!upcomings &&
                            upcomings.length > 0 && (
                              <Text textAlign="left" mt="4px">
                                {`Visit scheduled for ${upcomings[0].date} ${moment(upcomings[0].startTime, 'HH:mm').format('hh:mm A')}`}
                              </Text>
                            )}
                        </Flex>
                      </ButtonWithSelectionCircle>
                    ) : (
                      !!upcomings &&
                      upcomings.length > 0 && (
                        <ButtonWithSelectionCircle type="button" variant={'white'} mb={4} disabled={true}>
                          <Flex flex={1} flexDirection="column">
                            <Text textAlign="left" mt="4px">
                              Book thyroid visit
                            </Text>
                            {!!upcomings &&
                              upcomings.length > 0 && (
                                <Text textAlign="left" mt="4px">
                                  {`Visit scheduled for ${upcomings[0].date} ${moment(upcomings[0].startTime, 'HH:mm').format('hh:mm A')}`}
                                </Text>
                              )}
                          </Flex>
                        </ButtonWithSelectionCircle>
                      )
                    )}
                    {canBookNoHypo &&
                      (!upcomings || upcomings.length < 1) && (
                        <ButtonWithSelectionCircle
                          type="button"
                          variant={'white'}
                          onClick={() => props.history.push('/scheduling')}
                          disabled={(!!upcomings && upcomings.length > 0) || isRestrictedHypo()}
                        >
                          <Flex flex={1} flexDirection={['column', 'row']}>
                            <Text textAlign="left" mt="4px">
                              Book thyroid visit
                            </Text>
                          </Flex>
                        </ButtonWithSelectionCircle>
                      )}
                    
                  </>
                );
              } else {
                return null;
              }
            }}
          </Query>
        );
      }}
    </Query>
  );
};
const ScheduleSplitInner = (props) => {
  const [isDeepLoaded, setIsDeepLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [canBookNoHypo, setCanBookNoHypo] = useState(false);
  const [canBookVisit, setCanBookVisit] = useState(false);
  useEffect(
    () => {
      if (!props.session) {
        props.history.push('/');
        return;
      }
      const { history, dataUpcomings } = props;
      const { eligibility, intakeStatus, isMember, diagnoseFull, weightLossIntakeStatus, b2b } = props.session;
      const upcomings = ((dataUpcomings || {}).appointments || [])
        .filter((item) => {
          if (
            item.status &&
            item.status === 'f' &&
            !isAsyncAppointment(item.appointmentTypeId) &&
            !isMenoAppointment(item.appointmentTypeId) &&
            !isWeightLossAppointment(item.appointmentTypeId) &&
            !isNutritionistAppointment(item.appointmentTypeId)
          ) {
            return true;
          }
          return false;
        })
        .sort((a, b) => {
          const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
          const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
          if (ma.isBefore(mb)) return -1;
          return 1;
        });

      const upcomingsWeightLoss = ((dataUpcomings || {}).appointments || [])
        .filter((item) => {
          if (item.status && item.status === 'f' && isWeightLossAppointment(item.appointmentTypeId)) {
            return true;
          }
          return false;
        })
        .sort((a, b) => {
          const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
          const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
          if (ma.isBefore(mb)) return -1;
          return 1;
        });

      let canBookVisit = intakeStatus !== 'disqualified' && (!upcomings || upcomings.length < 1) && eligibility.consultation;
      let canBookWeightLoss = weightLossIntakeStatus !== 'disqualified' && (!upcomingsWeightLoss || upcomingsWeightLoss.length < 1) && eligibility.canBookWeightLoss;
      let canHypo = false;
      let canHypoNo = false;
      const hypoNoBooking = isToggleActive('ALLOW_HASHI_ONLY_BOOK');
      if (!!hypoNoBooking) {
        if (!canBookVisit) {
          if (!!diagnoseFull && (!!diagnoseFull.hasHypo || !!diagnoseFull.hasHashi)) {
            canHypoNo = true;
            setCanBookNoHypo(true);
            setCanBookVisit(false);
          } else if (!diagnoseFull || !diagnoseFull.hasHypo) {
            canHypoNo = true;
            setCanBookNoHypo(true);
            setCanBookVisit(false);
          }
        } else {
          if (!diagnoseFull || (!diagnoseFull.hasHypo && !diagnoseFull.hasHashi)) {
            canHypoNo = true;
            setCanBookNoHypo(true);
            setCanBookVisit(false);
          } else {
            canHypo = true;
            setCanBookNoHypo(false);
            setCanBookVisit(true);
          }
        }
      } else {
        if (!canBookVisit) {
          if (!diagnoseFull || !diagnoseFull.hasHypo) {
            canHypoNo = true;
            setCanBookNoHypo(true);
            setCanBookVisit(false);
          }
        } else {
          if (!diagnoseFull || !diagnoseFull.hasHypo) {
            canHypoNo = true;
            setCanBookNoHypo(true);
            setCanBookVisit(false);
          } else {
            canHypo = true;
            setCanBookNoHypo(false);
            setCanBookVisit(true);
          }
        }
      }

      setIsLoading(false);
      let restrictions = {
        hypo: false,
        meno: false,
        weighloss: false,
      };
      if (b2b && b2b.restrictions) {
        restrictions = b2b.restrictions;
      }
      if (props.session.gender === 'M') {
        if (restrictions.hypo) {
          if (!canBookWeightLoss && (!upcomingsWeightLoss || upcomingsWeightLoss.length < 1) && (!upcomings || upcomings.length < 1)) {
            history.push('/');
            return;
          }
        }
        if (canHypo) {
          return;
        } else if (canHypoNo) {
          return;
        } else {
          if (!canBookWeightLoss && (!upcomingsWeightLoss || upcomingsWeightLoss.length < 1) && (!upcomings || upcomings.length < 1)) {
            history.push('/');
          }
          return;
        }
      }

      if (!props.session.eligibility || (!props.session.eligibility.canBookPerimenopause && !props.session.eligibility.canBookPostmenopause)) {
        if (canHypo) {
        } else if (canHypoNo) {
        } else if (canBookWeightLoss) {
        } else {
          history.push('/');
          return;
        }
      }
    },
    [props],
  );
  if (isLoading) {
    return <PleaseWait />;
  }
  // if (props.session && props.session.eligibility && (props.session.eligibility.canBookPerimenopause || props.session.eligibility.canBookPostmenopause)) {
  return (
    <>
      <Container>
        <InnerContainerInformation p={3} mt={2} height={'auto'} style={{ height: 'auto !important' }} alignItems={'center'}>
          <Flex p={4} mb={4} style={{ background: 'transparent', backgroundColor: 'transparent', border: 0 }}>
            <Flex mb={4} flexDirection="column">
              <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
                <Flex flexDirection={'column'}>
                  {!!isDeepLoaded && (
                    <Heading mt={4} mb={4} textAlign={'center'}>
                      What kind of visit would you like to schedule?
                    </Heading>
                  )}

                  <InnerWithMenopause
                    {...props}
                    canBookNoHypo={canBookNoHypo}
                    canBookVisit={canBookVisit}
                    onLoaded={() => {
                      setIsDeepLoaded(true);
                    }}
                    isDeepLoaded={isDeepLoaded}
                  />
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </InnerContainerInformation>
      </Container>
    </>
  );
  // }

  return null;
};
const ScheduleSplit = (props) => {
  return (
    <Query query={APPOINTMENTS}>
      {({ data: dataUpcomings, loading: loadingUpcoming }) => {
        if (loadingUpcoming) {
          return (
            <Container alignItems={'center'} justifyContent={'center'}>
              <PleaseWait />
            </Container>
          );
        }

        return <ScheduleSplitInner {...props} dataUpcomings={dataUpcomings} />;
      }}
    </Query>
  );
};

export default withApollo(withRouter(withSession(withOnFileInsurance(withToastManager(ScheduleSplit)))));
